import React, { useState } from 'react';

//Redux
import { useSelector } from 'react-redux';

//Components
import CategoryList from './CategoryList';
import CategoryDialog from './CategoryDialog';

//MUI
import {
    FormGroup, Alert, Button, Accordion, AccordionSummary, AccordionDetails, Typography, Box
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// agregar nueva categoría
const CategorySelect = ({ setProdValues, prodCategory = [] }) => {
    // lista de categorías
    const { categories } = useSelector(state => state.category);

    const [open, setOpen] = useState(false);

    return (
        <>
            <Accordion defaultExpanded sx={{ boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                <AccordionSummary
                    sx={{
                        '&.Mui-expanded': {
                            borderBottom: '1px solid #E5E5E5'
                        },
                    }}
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography>Categorías</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{ my: 2 }}>
                        <Button
                            variant="outlined"
                            sx={{ textTransform: 'none' }}
                            startIcon={<AddIcon fontSize="inherit" />}
                            onClick={() => setOpen(!open)}
                        >
                            Agregar nueva categoría
                        </Button>
                    </Box>
                    <FormGroup>
                        {
                            categories.length <= 0 ?
                                <Alert severity="info">
                                    Añada una categoría
                                </Alert>
                                :
                                <CategoryList
                                    setProdValues={setProdValues}
                                    prodCategory={prodCategory}
                                />
                        }
                    </FormGroup>
                </AccordionDetails>
            </Accordion>

            <CategoryDialog
                open={open}
                setOpen={setOpen}
            />
        </>
    );
};

export default CategorySelect;
